<template>
  <div>
    <!-- 头部 -->
    <top></top>
    <div class="main">
      <navMenu :active="active"></navMenu>
      <div class="content content-type" v-loading.fullscreen.lock="loading">
        <div class="go-back" @click="goBack">返回</div>
        <div class="content-invitation">
          <div class="main-title pd m-none">{{ detail.name }}</div>
          <div class="main-sub pd m-none" v-html="content.content"></div>
          <div class="invitate-wrap pd">
            <!-- 下载模版 -->
            <div class="invitate-left" v-loading="posterLoading">
              <div class="down-img" id="posterHtml" v-if="!posterLoading">
                <el-image class="img-icon" :src="imgUrl"></el-image>
                <el-image
                  v-if="menu_mark == 'PcInvitation'"
                  class="img-bottom"
                  :src="imgbUrl"
                ></el-image>
                <el-image
                  v-else-if="menu_mark == 'CphiInvitation'"
                  class="img-bottom"
                  :src="imgbUrl2"
                ></el-image>
                <el-image v-else class="img-bottom" :src="imgbUrl1"></el-image>
                <div
                  class="booth"
                  :class="{
                    bg1: menu_mark == 'PcInvitation',
                    bg2: menu_mark == 'CphiInvitation',
                    boothbottom: userdata.name_cn.length > 10,
                  }"
                >
                  {{ userdata.hallNo }}{{ userdata.boothNo }}
                </div>
                <div
                  class="name"
                  :class="{
                    bg1: menu_mark == 'PcInvitation',
                    bg2: menu_mark == 'CphiInvitation',
                  }"
                >
                  {{ userdata.name_cn }}
                </div>
                <div class="wx-code">
                  <img
                    v-if="wxCodeUrl"
                    :src="wxCodeUrl"
                    alt=""
                    class="code-img"
                  />
                  <p>扫码进入</p>
                  <p>企业店铺</p>
                </div>
                <qr-code
                  v-if="codeUrlLink"
                  :text="codeUrlLink"
                  :index="0"
                  class="code-icon"
                ></qr-code>
              </div>
              <div class="down-mask" v-if="!posterLoading">
                <a class="down-btn" @click="downPoster">下载邀请函</a>
                <a class="down-btn" @click="diyPoster">自定义邀请函</a>
              </div>
            </div>
            <!-- 列表 -->
            <div class="invitation-table">
              <div class="table-title">
                已邀请观众列表<span>(总邀请人数{{ totalNum }})</span
                ><span class="rank" @click="isShowRank = true"
                  >排行榜 <i class="el-icon-d-arrow-right"></i
                ></span>
              </div>
              <el-table
                class="my-table"
                :data="audienceList"
                stripe
                style="width: 100%"
                :header-cell-style="{
                  fontSize: '14px',
                }"
                :cell-style="{ fontSize: '14px' }"
              >
                <el-table-column label="姓名">
                  <template slot-scope="scope">
                    {{ scope.row.customerName }}
                  </template>
                </el-table-column>
                <el-table-column label="公司">
                  <template slot-scope="scope">
                    {{ scope.row.companyName }}
                  </template>
                </el-table-column>
                <el-table-column label="部门">
                  <template slot-scope="scope">
                    {{ scope.row.deptName }}
                  </template>
                </el-table-column>
                <el-table-column label="职务">
                  <template slot-scope="scope">
                    {{ scope.row.job }}
                  </template>
                </el-table-column>
                <el-table-column label="登记时间">
                  <template slot-scope="scope">
                    {{ scope.row.createTime }}
                  </template>
                </el-table-column>
              </el-table>
              <el-pagination
                style="text-align: right"
                v-if="totalNum > 0"
                background
                @current-change="handleCurrentChange"
                :current-page.sync="page"
                :page-size="pagesize"
                layout="total, prev, pager, next"
                :total="totalNum"
              >
              </el-pagination>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 排行榜 -->
    <el-dialog title="排行榜" :visible.sync="isShowRank" width="372px">
      <div class="rank-list">
        <el-table
          ref="multipleTable"
          :data="rankData"
          tooltip-effect="dark"
          style="width: 100%"
        >
          <el-table-column label="排行" width="76">
            <template slot-scope="scope">
              <div v-if="scope.row.sort <= 3" class="rank-number">
                {{ scope.row.sort }}
              </div>
              <div v-else class="rank-number rank-defalut">
                {{ scope.row.sort }}
              </div>
            </template>
          </el-table-column>
          <el-table-column
            label="公司名称"
            prop="orgName"
            width="195"
          ></el-table-column>
          <el-table-column
            label="数量"
            prop="count"
            width="50"
          ></el-table-column>
        </el-table>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  getDetail,
  starAudienceList,
  statistics,
  registrationUrl,
  invitationBgLists,
  skipOrReadStep,
  getUnlimited,
} from "@/api/api";
import top from "../components/top.vue"; //头部
import navMenu from "../components/navMenu.vue"; //左侧步骤条
import html2canvas from "html2canvas";
import QrCode from "../components/qrcode.vue";
export default {
  components: { top, navMenu, QrCode },
  name: "invitation",
  data() {
    return {
      loading: false,
      posterLoading: false,
      active: 4,
      content: {
        content: "",
      },
      detail: {},
      audienceList: [],
      page: 1,
      pagesize: 10,
      totalNum: "",
      codeUrl: "",
      bgUrl: require("../assets/bgimg.jpg"),
      bgUrlNhne: require("../assets/bgimg1.jpg"),
      bgUrlCphi: require("../assets/bgimg2.jpg"),
      imgUrl: "",
      userdata: {
        hallNo: "",
        boothNo: "",
        name_cn: "",
      },
      options: [
        {
          value: 1,
          label: "公司名",
        },
        {
          value: 2,
          label: "品牌名",
        },
      ],
      headers: {},
      imgbUrl: require("../assets/poster_bg.png"),
      imgbUrl1: require("../assets/poster_bg1.png"),
      imgbUrl2: require("../assets/poster_bg2.png"),
      value: 1,
      imgs: [], // 背景图片
      currentIndex: 0,
      makeImgs: [], //已制作的邀请函列表
      menu_mark: "",
      isShowRank: false, //是否显示排行榜弹框
      rankData: [],
      codeUrlLink: "",
      wxCodeUrl: "", //微信小程序码
    };
  },
  mounted() {
    let stepMenuList = JSON.parse(localStorage.getItem("menu"));
    this.stepMenuList = stepMenuList;
    var index = stepMenuList.findIndex(function (item) {
      return item.link_url == "conference" && item.id == 22;
    });
    this.detail = stepMenuList[index];
    console.log(this.detail, "=====detail");
    this.active = index;
    this.menu_mark = this.$route.query.mark;
    this.userdata = JSON.parse(localStorage.getItem("userdata"));
    this.getContent(this.detail.id);
    //获取邀请函二维码链接
    this.getRegistrationUrl();
    //24.9.29 获取小程序码 dxm
    this.getUnlimitedCode();
    //获取默认邀请函背景图
    this.getBgList();
    //获取已邀请观众列表
    this.getAudienceList();
    //获取排行榜数据
    this.getStatistics();
  },
  methods: {
    // 返回
    goBack() {
      this.$router.back();
    },
    //获取邀请函二维码链接
    getRegistrationUrl() {
      let data = this.$qs.stringify({
        mark: this.menu_mark,
      });
      registrationUrl(data)
        .then((res) => {
          if (res.data.code == 1) {
            let { data } = res.data;
            this.codeUrlLink = data.url;
          }
        })
        .catch((err) => {});
    },
    //获取邀请函背景
    getBgList() {
      this.posterLoading = true;
      invitationBgLists(this.menu_mark)
        .then((res) => {
          if (res.data.code == 1) {
            let { data } = res.data;
            let imgs = data.lists[0].image;
            if (imgs.substring(0, 1) == "/") {
              imgs = imgs.substring(1);
            }
            //背景默认第一个
            this.imgUrl = this.$imgOssUrl + imgs;
            this.posterLoading = false;
          }
        })
        .catch((err) => {});
    },
    //24.9.29 获取小程序二维码 dxm
    getUnlimitedCode() {
      let data = this.$qs.stringify({
        page: "pages/show/qydetail/qydetail",
      });
      getUnlimited(data)
        .then((res) => {
          let data = res.data;
          this.wxCodeUrl = window.URL.createObjectURL(
            new Blob([data], { type: "image/jpeg" })
          );
        })
        .catch((err) => {});
    },
    //自定义邀请函
    diyPoster() {
      this.skipOrReadStepHandle();
      this.$router.push({
        path: "/invitation",
        query: {
          mark: this.menu_mark,
        },
      });
    },
    // 下载邀请函时
    downPoster() {
      let that = this;
      that.loading = true;
      that.skipOrReadStepHandle();
      let image = that.imgUrl;
      that.convertImageToBase64(image, that.base64CallBack);
      let posterDOM = document.getElementById("posterHtml");
      html2canvas(posterDOM, {
        width: posterDOM.offsetWidth,
        height: posterDOM.offsetHeight,
        //按比例增加分辨率
        scale: window.devicePixelRatio * 2, // 设备像素比
        useCORS: true, //（图片跨域相关）
        allowTaint: true, //允许跨域（图片跨域相关）
        logging: false,
        letterRendering: true,
      }).then(function (canvas) {
        let posterImgURL = canvas.toDataURL();
        let a = document.createElement("a");
        a.download = "邀请函";
        a.href = posterImgURL;
        a.dispatchEvent(new MouseEvent("click"));
        that.loading = false;
      });
    },
    //下载邀请函时，图片转base64
    convertImageToBase64(imgUrl, callback) {
      const image = new Image();
      image.crossOrigin = "Anonymous"; // 设置跨域属性
      image.src = imgUrl;
      image.onload = () => {
        const canvas = document.createElement("canvas");
        const ctx = canvas.getContext("2d");
        canvas.height = image.naturalHeight;
        canvas.width = image.naturalWidth;
        ctx.drawImage(image, 0, 0);
        const dataUrl = canvas.toDataURL();
        callback && callback(dataUrl);
      };
      image.onerror = (error) => {
        console.error("图加载失败", error);
      };
    },
    //  获取内容
    getContent(id) {
      getDetail({ id })
        .then((res) => {
          if (res.data.code == 1) {
            let { data } = res.data;
            this.content = data;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    // 分页相关
    handleCurrentChange(val) {
      this.page = val;
      this.getAudienceList();
    },
    //获取观众列表
    getAudienceList() {
      let data = this.$qs.stringify({
        nowPage: this.page,
        pageSize: 10,
        mark: this.menu_mark,
      });
      starAudienceList(data)
        .then((res) => {
          if (res.data.code == 1) {
            let { data } = res.data;
            this.audienceList = data.results;
            this.totalNum = data.totalNum;
          }
        })
        .catch((err) => {});
    },
    //获取排行榜列表
    getStatistics() {
      let data = this.$qs.stringify({
        mark: this.menu_mark,
      });
      statistics(data)
        .then((res) => {
          if (res.data.code == 1) {
            let { data } = res.data;
            this.rankData = data;
          }
        })
        .catch((err) => {});
    },
    // 跳过
    skipOrReadStepHandle() {
      let data = {
        action: 2,
        mark: this.menu_mark,
      };
      skipOrReadStep(data)
        .then((res) => {
          if (res.data.code == 1) {
            //this.$message.success("操作成功");
          } else {
            //this.$message.error(res.data.msg);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
};
</script>
<style lang="scss" scoped>
.red{
  color: red;
}
.go-back {
  margin: 0 0 20px 20px;
}
.content-invitation {
  margin: 0 20px;
  padding: 30px 0 150px;
  background: #fff;
  border-radius: 10px;
  .invitate-wrap {
    display: flex;
    margin-top: 20px;
  }
  .invitate-left {
    margin-right: 60px;
    position: relative;
    width: 350px;
    height: 624px;
    .down-mask {
      width: 100%;
      height: 100%;
      position: absolute;
      top: 0;
      left: 0px;
      z-index: 9;
      padding-top: 60%;
      box-sizing: border-box;
      background: rgba(0, 0, 0, 0.4);
      .down-btn {
        width: 136px;
        height: 40px;
        font-size: 16px;
        font-weight: 500;
        color: #fff;
        cursor: pointer;
        line-height: 40px;
        text-align: center;
        background: #1677ff;
        border-radius: 5px;
        margin: 30px auto 0;
      }
    }
  }
  .down-img {
    width: 350px;
    height: auto;
    cursor: pointer;
    position: relative;
    .img-icon {
      width: 100%;
      height: 100%;
    }
    .img-bottom {
      position: absolute;
      bottom: 0;
      left: 0;
      width: 100%;
    }
    .name {
      position: absolute;
      // bottom: 175px;
      top: 375px;
      left: 0;
      width: 67%;
      color: #fff;
      font-size: 22px;
      font-weight: 500;
      padding: 5px 20px;
      display: flex;
      align-items: center;
      box-sizing: border-box;
      min-height: 35px;
      line-height: 25px;
      background: rgba(0, 0, 0, 0.15);
    }
    .booth {
      position: absolute;
      bottom: 256px;
      left: 0;
      width: 67%;
      color: #fff;
      font-size: 26px;
      font-weight: 500;
      padding: 8px 20px;
      box-sizing: border-box;
      background: rgba(0, 0, 0, 0.15);
    }
    .boothbottom {
      bottom: 245px;
    }
    .bg1 {
      background: rgba(229, 22, 38, 0.8);
    }
    .bg2 {
      background: rgba(122, 180, 44, 0.9);
    }
    .code-icon {
      position: absolute;
      z-index: 9;
      bottom: 46px;
      right: 18px;
      width: 82px;
      height: 82px;
      /deep/ canvas {
        width: 100% !important;
        height: 100% !important;
      }
    }
    .wx-code {
      position: absolute;
      bottom: 184px;
      right: 10px;
      width: 98px;
      color: #fff;
      font-size: 12px;
      text-align: center;
      .code-img {
        width: 82px;
        height: 82px;
      }
      p {
        margin: 0;
        line-height: 15px;
        font-weight: 300;
        transform: scale(0.9);
      }
    }
  }
  // 已邀请观众列表
  .invitation-table {
    flex: 1;
    position: relative;
    .table-title {
      font-size: 20px;
      font-weight: 500;
      color: #2c2c2e;
      line-height: 28px;
      position: relative;
      span {
        font-size: 16px;
        color: #636366;
      }
      .rank {
        color: #fff;
        font-size: 13px;
        padding: 0 10px;
        border-radius: 5px;
        background: #fc933f;
        font-weight: 500;
        cursor: pointer;
        position: absolute;
        top: 0;
        right: 0;
      }
    }
  }
}
.my-table {
  color: #888;
  font-size: 16px;
  margin-top: 10px;
}
.my-table tbody td,
.my-table tbody th {
  height: 70px;
  box-sizing: border-box;
}
.my-table tbody th,
.my-table tbody tr {
  background: #f2f6fb;
}
.my-table tbody tr.is-new {
  color: #0e0e0e;
}
.my-table tbody tr td .check-btn {
  color: #1677ff;
  cursor: pointer;
}
.el-table--striped .el-table__body tr.el-table__row--striped td {
  background: #fff;
}
.el-table td,
.el-table th.is-leaf {
  border-bottom: 0 none;
}
/* 表格最外层边框-底部边框 */
.el-table--border::after,
.el-table--group::after {
  width: 0;
}
.my-table::before {
  width: 0;
}
.my-table tbody tr td:first-child {
  border-radius: 10px 0 0 10px;
}
.my-table tbody tr td:last-child {
  border-radius: 0 10px 10px 0;
}
.content-invitation .el-pagination {
  position: absolute;
  bottom: 0;
  right: 0;
  background: #fff;
  padding: 10px 0;
  border-radius: 6px;
  .el-pager li,
  .el-pagination__total {
    font-size: 14px;
  }
  .el-pagination__jump {
    font-size: 14px;
  }
}
.rank-list {
  border-top: 1px solid #eee;
  .rank-number {
    width: 20px;
    height: 20px;
    font-size: 14px;
    color: #fff;
    line-height: 20px;
    text-align: center;
    border-radius: 50%;
    background: #eab572;
  }
  .rank-defalut {
    color: #666;
    background: transparent;
  }
}
/deep/ .el-dialog {
  margin-top: 0 !important;
  border-radius: 10px;
}
/deep/ .el-dialog__body {
  padding: 10px 25px 25px;
}
/deep/ .el-dialog__wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>